
import config from "../../helper/config";
import APIHandler from "../../handlers/APIHandler";
import DataHandler from "../../handlers/DataHandler";

export const assessmentService = {
    createAssessment: createAssessment,
    deleteAssessment: deleteAssessment,
    editDetails: editDetails,
    scheduleAssessment: scheduleAssessment,
    editScheduleAssessment: editScheduleAssessment,
    assignAssessors: assignAssessors,
    editAssessors: editAssessors,
    editCandidates: editCandidates,
    finalizeAssessment: finalizeAssessment,
    getAssessmentLanguage: getAssessmentLanguage,
    getAssessmentCategories: getAssessmentCategories,
    getAssessmentDifficulty: getAssessmentDifficulty,
    getAssessmentGrade: getAssessmentGrade,
    getAssessmentSubject: getAssessmentSubject,
    getAssessmentAuthor: getAssessmentAuthor,
    getAssessmentYear: getAssessmentYear,
    getAssessmentTerm: getAssessmentTerm,
    getAssessmentChapter: getAssessmentChapter,
    getAssessmentAttempt: getAssessmentAttempt,
    getAssessmentPrivilege: getAssessmentPrivilege,
    getCounts: getCounts,
    getLatestAssessments: getLatestAssessments,
    getAllAssessmentsCount: getAllAssessmentsCount,
    getTotalSharedAssessmentsCount: getTotalSharedAssessmentsCount,
    getTotalPublicAssessmentsCount: getTotalPublicAssessmentsCount,
    getAllAssessments: getAllAssessments,
    getAllAssessmentMetaData: getAllAssessmentMetaData,
    getAllAssessmentMetaDataWithCount: getAllAssessmentMetaDataWithCount,
    getAssessmentPartSectionData: getAssessmentPartSectionData,
    addAssessmentPartSection:addAssessmentPartSection,
    addAssessmentPart:addAssessmentPart,
    getSectionsAndPartsByAssessment:getSectionsAndPartsByAssessment,
    updateAssessmentQuestionSection: updateAssessmentQuestionSection,
    updatePart:updatePart,
    updateSection:updateSection,
    get_restart_pause_status:get_restart_pause_status,
    getAllMUltipleAssessmentDetails :getAllMUltipleAssessmentDetails,
};


async function getAllAssessments(count) {
    const requestOptions = {
        method: 'GET',
        headers: APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
    };

    return await fetch(`${config.oat_api_url}/assessments/getAllAssessments?count=${count}`, requestOptions).then(APIHandler.handleResponse);
}

async function createAssessment(obj) {
    const requestOptions = {
        method: 'POST',
        headers: APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
        body: JSON.stringify(obj)
    };

    return await fetch(`${config.oat_api_url}/assessments/add/`, requestOptions).then(APIHandler.handleResponse);
}

async function editDetails(obj) {

    let requestBody = {
        created_by: obj.userID,
        assessment_id: obj.editAssessmentId,
        title: obj.editTitle,
        assessment_admin: obj.editAssessmentAdminId,
        proctor_requirement: obj.editProctorRequirement,
        assessment_state: obj.assessment_state,
        language_id: obj.language_id,
        category_id: obj.category_id,
        difficulty_id: obj.difficulty_id,
        terms_content: obj.terms_content,
        attempt_no_id: parseInt(obj.attempt_no_id),
        grade_id: obj.grade_id,
        author_id: obj.author_id,
        source_id: obj.source_id,
        chapter_id: obj.chapter_id,
        subject_id: obj.subject_id,
        term_id: obj.term_id,
        privilege_id: parseInt(obj.editPrivilege),
        status_id: parseInt(obj.status_id),
        year_id: obj.year_id,
        exam_category_id: obj.exam_category_id,
        additional_info: obj.additional_info,
        template_id: obj.template_id?parseInt(obj.template_id):null,
        no_of_parts: obj.no_of_parts,
        part_notation_id: obj.part_notation_id,
        is_restart: obj.is_restart,
        is_pause: obj.is_pause,
        pause_until: obj.pause_until,
        is_multiple: obj.is_multiple,
        is_master: obj.is_master,
        parent_assessment_id: obj.parent_assessment_id,
        grading_method_id: obj.grading_method_id,
    };
   
    const requestOptions = {
        method: 'POST',
        headers: APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
        body: JSON.stringify(requestBody)
    };

    const response = await fetch(`${config.oat_api_url}/assessments/update/${obj.editAssessmentId}`, requestOptions);
    return APIHandler.handleResponse(response);
}

async function scheduleAssessment(obj) {
    const requestOptions = {
        method: 'POST',
        headers: APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
        body: JSON.stringify(obj)
    };

    const response = await fetch(`${config.oat_api_url}/assessment/schedules/add/`, requestOptions);
    return APIHandler.handleResponse(response);
}

async function getAssessmentLanguage() {
    const requestOptions = {
        method: 'GET',
        headers: APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
    };

    const response = await fetch(`${config.oat_api_url}/manage/languages/getAll/`, requestOptions);
    return APIHandler.handleResponse(response);
}

async function getAssessmentPrivilege() {
    const requestOptions = {
        method: 'GET',
        headers: APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
    };

    const response = await fetch(`${config.oat_api_url}/manage/privileges/getAll/`, requestOptions);
    return APIHandler.handleResponse(response);
}

async function getAssessmentCategories() {
    const requestOptions = {
        method: "GET",
        headers: APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
    };

    return await fetch(
        `${config.oat_api_url}/assessment/categories/getAll/`,
        requestOptions
    ).then(APIHandler.handleResponse);
}

async function getAssessmentDifficulty() {
    const requestOptions = {
        method: "GET",
        headers: APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
    };

    const response = await fetch(
        `${config.oat_api_url}/manage/difficulties/getAll/`,
        requestOptions
    );
    return APIHandler.handleResponse(response);
}

async function getAssessmentGrade() {
    const requestOptions = {
        method: "GET",
        headers: APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
    };

    const response = await fetch(
        `${config.oat_api_url}/manage/grades/getAll/`,
        requestOptions
    );
    return APIHandler.handleResponse(response);
}

async function getAssessmentSubject() {
    const requestOptions = {
        method: "GET",
        headers: APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
    };

    const response = await fetch(
        `${config.oat_api_url}/manage/subjects/getAll/`,
        requestOptions
    );
    return APIHandler.handleResponse(response);
}

async function getAssessmentAuthor() {
    const requestOptions = {
        method: "GET",
        headers: APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
    };

    const response = await fetch(
        `${config.oat_api_url}/manage/authors/getAll/`,
        requestOptions
    );
    return APIHandler.handleResponse(response);
}

async function getAssessmentYear() {
    const requestOptions = {
        method: "GET",
        headers: APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
    };

    const response = await fetch(
        `${config.oat_api_url}/manage/years/getAll/`,
        requestOptions
    );
    return APIHandler.handleResponse(response);
}

async function getAssessmentTerm() {
    const requestOptions = {
        method: "GET",
        headers: APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
    };

    const response = await fetch(
        `${config.oat_api_url}/manage/terms/getAll/`,
        requestOptions
    );
    return APIHandler.handleResponse(response);
}

async function getAssessmentChapter() {
    const requestOptions = {
        method: "GET",
        headers: APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
    };

    const response = await fetch(
        `${config.oat_api_url}/manage/chapters/getAll/`,
        requestOptions
    );
    return APIHandler.handleResponse(response);
}

async function getAssessmentAttempt() {
    const requestOptions = {
        method: "GET",
        headers: APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
    };

    const response = await fetch(
        `${config.oat_api_url}/assessment/attempts/getAll/`,
        requestOptions
    );
    return APIHandler.handleResponse(response);
}


async function editScheduleAssessment(obj) {
    let requestBody = {
        user_id: obj.userID,
        assessment_id: obj.editAssessmentId,
        start_time: obj.editStartTime,
        exam_time_interval: obj.editTestDuration,
        buffer_time: obj.editAccessBuffer,
        exam_time_interval_unit_id: obj.editTimeUnit,
        buffer_time_unit_id: obj.editBufferTimeUnit,
        is_set_time_limit: obj.editSetTimeLimit
    }
    const requestOptions = {
        method: 'POST',
        headers: APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
        body: JSON.stringify(requestBody)
    };

    const response = await fetch(`${config.oat_api_url}/assessment/schedules/update/${obj.editAssessmentId}`, requestOptions);
    return APIHandler.handleResponse(response);
}

async function editCandidates(obj) {
    let requestBody = {
        user_id: obj.userID,
        candidates: obj.editSelectedCandidates,
        candidate_id: obj.edit_candidate_id

    }
    const requestOptions = {
        method: 'POST',
        headers: APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
        body: JSON.stringify(requestBody)
    };


    const response = await fetch(`${config.oat_api_url}/candidates/update/${obj.edit_assessment_id}`, requestOptions);
    return APIHandler.handleResponse(response);
}


async function assignAssessors(obj) {
    const requestOptions = {
        method: 'POST',
        headers: APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
        body: JSON.stringify(obj)
    };

    return await fetch(`${config.oat_api_url}/assessment/assessors/add/`, requestOptions).then(APIHandler.handleResponse);
}

async function editAssessors(obj) {
    const requestOptions = {
        method: 'POST',
        headers: APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
        body: JSON.stringify(obj)
    };

    const response = await fetch(`${config.oat_api_url}/assessment/assessors/edit/`, requestOptions);
    return APIHandler.handleResponse(response);
}


async function deleteAssessment(obj) {
    let requestBody = {
        user_id: obj.userID,
        assessment_id: obj.deleteAssessmentId
    }

    const requestOptions = {
        method: 'POST',
        headers: APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
        body: JSON.stringify(requestBody)
    };

    const response = await fetch(`${config.oat_api_url}/assessments/delete/${obj.deleteAssessmentId}`, requestOptions);
    return APIHandler.handleResponse(response);
}

async function finalizeAssessment(obj) {
    const requestOptions = {
        method: 'POST',
        headers: APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
        body: JSON.stringify(obj)
    };

    return await fetch(`${config.oat_api_url}/assessments/finalizeAssessment/`, requestOptions).then(APIHandler.handleResponse);
}

async function getCounts() {
    const requestOptions = {
        method: 'GET',
        headers: APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
    };

    const response = await fetch(`${config.oat_api_url}/assessments/getCounts/`, requestOptions);
    return APIHandler.handleResponse(response);
}

async function getLatestAssessments() {
    const requestOptions = {
        method: 'GET',
        headers: APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
    };

    const response = await fetch(`${config.oat_api_url}/assessments/get-latest-assesments`, requestOptions);
    return APIHandler.handleResponse(response);
}

async function getAllAssessmentsCount(user_id) {
    const requestOptions = {
        method: 'GET',
        headers: APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
    };

    const response = await fetch(`${config.oat_api_url}/assessments/getAllAssessmentsCount/${user_id}`, requestOptions);
    return APIHandler.handleResponse(response);
}

async function getTotalSharedAssessmentsCount(user_id, search_term = "") {
    const requestOptions = {
        method: 'GET',
        headers: APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
    };

    const response = await fetch(`${config.oat_api_url}/assessments/getTotalSharedAssessmentsCount/${user_id}?search_term=${search_term}`, requestOptions);
    return APIHandler.handleResponse(response);
}

async function getTotalPublicAssessmentsCount() {
    const requestOptions = {
        method: 'GET',
        headers: APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
    };

    const response = await fetch(`${config.oat_api_url}/assessments/getTotalPublicAssessmentsCount/`, requestOptions);
    return APIHandler.handleResponse(response);
}

async function getAllAssessmentMetaData() {
    const requestOptions = {
        method: 'GET',
        headers: APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
    };

    const response = await fetch(`${config.oat_api_url}/assessments/get-all-meta-data/`, requestOptions);
    return APIHandler.handleResponse(response);
}

async function getAllAssessmentMetaDataWithCount() {
    var user_id = DataHandler.getFromSession("user_id")
    const requestOptions = {
        method: 'GET',
        headers: APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
    };

    const response = await fetch(`${config.oat_api_url}/assessments/get-all-meta-data-with-count/${user_id}`, requestOptions);
    return APIHandler.handleResponse(response);
}


async function getAssessmentPartSectionData(assessment_id) {
    const requestOptions = {
        method: 'GET',
        headers: APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
    };

    const response = await fetch(`${config.oat_api_url}/assessments/get-part-section-data/${assessment_id}`, requestOptions);
    return APIHandler.handleResponse(response);
}

async function addAssessmentPartSection(sectionObj) {

    const requestOptions = {
        method: 'POST',
        headers: APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
        body: JSON.stringify(sectionObj)
    };

    const response = await fetch(`${config.oat_api_url}/assessments/add-assessment-part-section`, requestOptions);
    return APIHandler.handleResponse(response);
}

async function addAssessmentPart(partObj) {

    const requestOptions = {
        method: 'POST',
        headers: APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
        body: JSON.stringify(partObj)
    };

    const response = await fetch(`${config.oat_api_url}/assessments/add-assessment-part`, requestOptions);
    return APIHandler.handleResponse(response);
}

async function getSectionsAndPartsByAssessment(assessment_id){
  
  try {

          const url = `${config.oat_api_url}/assessments/get-parts-and-sections-for-assessment/${assessment_id}`;
    
          const requestOptions = {
            method: 'GET',
            headers: APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
          };
    
          const response = await fetch(url, requestOptions);
    
          if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
          }
  
          return await APIHandler.handleResponse(response);
  
  
      } catch (error) {
          console.error('Error fetching parts:', error);
      }
}

async function updatePart(part,assessment_part_id){
  
  try {

          const url = `${config.oat_api_url}/assessments/update-part/${assessment_part_id}`;
    
          const requestOptions = {
            method: 'POST',
            headers: APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
            body: JSON.stringify(part)
          };
    
          const response = await fetch(url, requestOptions);
    
          if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
          }
  
          return await APIHandler.handleResponse(response);
  
  
      } catch (error) {
          console.error('Error fetching parts:', error);
      }
}

async function updateSection(section,part_section_id){
  
  try {

          const url = `${config.oat_api_url}/assessments/update-section/${part_section_id}`;
    
          const requestOptions = {
            method: 'POST',
            headers: APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
            body: JSON.stringify(section)
          };
    
          const response = await fetch(url, requestOptions);
    
          if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
          }
  
          return await APIHandler.handleResponse(response);
  
  
      } catch (error) {
          console.error('Error fetching parts:', error);
      }
}

async function updateAssessmentQuestionSection(obj) {

    let requestBody = {
        assessment_id: obj.assessment_id,
        section_id: obj.section_id,
        question_ids: obj.question_ids
    }
    const requestOptions = {
        method: 'POST',
        headers: APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
        body: JSON.stringify(requestBody)
    };

    const response = await fetch(`${config.oat_api_url}/assessment/questions/update-section/`, requestOptions);
    return APIHandler.handleResponse(response);
}

async function get_restart_pause_status(assessment_id) {
  const requestOptions = {
    method: 'GET',
    headers: APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
    
  };
  
  const response = await fetch(`${config.oat_api_url}/assessments/get_restart_pause_status/${assessment_id}`, requestOptions);
  return  await APIHandler.handleResponse(response);
  
  
}
async function getAllMUltipleAssessmentDetails() {
  const requestOptions = {
    method: "GET",
    headers: APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
  };
  return fetch(
    `${config.oat_api_url}/assessment/links/getAll/multipleDetails`,
    requestOptions
  ).then(APIHandler.handleResponse);
}
